<template>
  <v-dialog
    id="ActionDialogComponent"
    v-model="actionDialog.show"
    max-width="350"
    attach
  >
    <v-card
      :loading="loading"
      :disabled="disabled"
    >
      <v-card-title class="headline">
        Are you sure?
      </v-card-title>
      <v-card-text>
        Are you sure you want to {{ actionDialog.action }} {{ actionDialog.item.name }}?
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="red"
          text
          @click="closeDialog()"
        >
          Cancel
        </v-btn>
        <v-spacer />
        <v-btn
          color="green"
          text
          @click="confirm()"
        >
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'ActionDialogComponent',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    actionDialog: {
      type: Object,
      default: () => {
        return {
          show: false,
          action: '',
          item: {}
        }
      }
    }
  },
  data: () => ({
    //
  }),
  computed: {
    //
  },
  created () {
    //
  },
  methods: {
    confirm () {
      switch (this.actionDialog.action) {
        case 'delete':
          this.$emit('deleteItem')
          break
        case 'update':
          this.$emit('updateItem')
          break
        case 'cancel':
          this.$emit('cancelItem')
          break
        case 'discard':
          this.$emit('discardItem')
          break
        case 'disable':
          this.$emit('disableItem')
          break
        case 'enable':
          this.$emit('enableItem')
          break
        case 'restore':
          this.$emit('restoreItem')
          break

        default:
          break
      }
    },
    closeDialog () {
      this.$emit('closeDialog')
    }
  }
}
</script>
<style lang='scss'>
    #ActionDialogComponent {
        //
    }
</style>
